module.exports = __webpack_public_path__ + "static/img/54-2.7e4749c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/54-2.jpg
// module id = LafZ
// module chunks = 0